import { withErrorBoundary } from '../dependencies';

import ExpensesList from '../components/ExpensesList';

export default withErrorBoundary(ExpensesList);
